import React from "react";

import { HiExclamation, HiInformationCircle } from "react-icons/hi";
import { brandSystemName } from "../../branding";

// Each tenant has its own, near-identical admin site. Show loudly which one is being configured.
export const SettingsTenantBanner = () => {
  const tenantId = import.meta.env.VITE_TENANT_ID;

  if (!tenantId) {
    return (
      <div
        role="alert"
        className="flex items-start gap-3 rounded-lg border-l-4 border-rose-500 bg-rose-50 px-4 py-3 text-rose-900 dark:bg-rose-500/10 dark:text-rose-200"
      >
        <HiExclamation className="mt-0.5 shrink-0" size={24} />
        <div>
          <div className="text-lg font-semibold">Konfigurujesz system: {brandSystemName} (tenant: nie ustawiono)</div>
          <div className="text-sm">
            Brak VITE_TENANT_ID w tej wersji panelu. API odrzuci wszystkie żądania, sprawdź konfigurację wdrożenia.
          </div>
        </div>
      </div>
    );
  }

  return (
    <div
      role="status"
      className="flex items-start gap-3 rounded-lg border-l-4 border-indigo-500 bg-indigo-50 px-4 py-3 text-indigo-900 dark:bg-indigo-500/10 dark:text-indigo-200"
    >
      <HiInformationCircle className="mt-0.5 shrink-0" size={24} />
      <div>
        <div className="text-lg">
          Konfigurujesz system: <span className="font-bold">{brandSystemName}</span> (tenant:{" "}
          <span className="font-mono font-bold">{tenantId}</span>)
        </div>
        <div className="text-sm opacity-80">
          Zmiany na tej stronie dotyczą tylko tego systemu. Upewnij się, że to właściwy panel.
        </div>
      </div>
    </div>
  );
};
